// @react/hooks/usePlatformFederation.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { platformFederationStore } from '@core/stores';

/**
 * React hook for ConsentRecord operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { usePlatformFederation } from '@react/hooks';
 *
 * const ConsentRecordList = observer(() => {
 *   const store = usePlatformFederation();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function usePlatformFederation() {
  return platformFederationStore;
}
